import React from 'react'

import { InputContainer, IconContainer, Input } from './InputWithIcon.styled'

interface InputWithIconProp {
  value: string
  onChange: (v: string) => void
  icon: React.ReactNode
  placeholder?: string
  disabled?: boolean
  width?: string
}

export const InputWithIcon = ({
  value,
  icon,
  onChange,
  placeholder,
  disabled,
  width,
}: InputWithIconProp) => {
  return (
    <InputContainer css={{ width: `${width ? width : 'auto'}` }}>
      <IconContainer>{icon}</IconContainer>
      <Input
        value={value || ''}
        type="text"
        disabled={disabled}
        placeholder={placeholder || ''}
        onChange={(e) => onChange(e.target.value)}
      />
    </InputContainer>
  )
}
